import { defineComponent as _defineComponent } from 'vue'
import {
  TUIStore,
  StoreName,
  IConversationModel,
} from '@tencentcloud/chat-uikit-engine';
import { ref, onMounted } from '../../../adapter-vue';
import MessageInputEditor from './message-input-editor.vue';
import MessageInputAt from './message-input-at/index.vue';
import MessageInputButton from './message-input-button.vue';
import MessageInputQuote from './message-input-quote/index.vue';
import { sendMessages, sendTyping } from '../utils/sendMessage';
import { transformTextWithEmojiNamesToKeys } from '../emoji-config';
import { inject } from 'vue';
import { isPC, isH5 } from '../../../utils/env';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  placeholder: {
    type: String,
    default: 'this is placeholder',
  },
  isMuted: {
    type: Boolean,
    default: true,
  },
  muteText: {
    type: String,
    default: '',
  },
  enableInput: {
    type: Boolean,
    default: true,
  },
  enableAt: {
    type: Boolean,
    default: true,
  },
  enableDragUpload: {
    type: Boolean,
    default: true,
  },
  enableTyping: {
    type: Boolean,
    default: true,
  },
},
  emits: ['sendMessage', 'resetReplyOrReference', 'onTyping'],
  setup(__props, { expose, emit }) {

const props = __props




const editor = ref<InstanceType<typeof MessageInputEditor>>();
const messageInputAtRef = ref<InstanceType<typeof MessageInputAt>>();
const currentConversation = ref<IConversationModel>();

TUIStore.watch(StoreName.CONV, {
  currentConversation: (conversation: IConversationModel) => {
    currentConversation.value = conversation;
  },
});

const onTyping = (inputContentEmpty: boolean, inputBlur: boolean) => {
  sendTyping(inputContentEmpty, inputBlur);
};

const onAt = (show: boolean) => {
  messageInputAtRef.value?.toggleAtList(show);
};

onMounted(() => {
  let notification = inject('$_home')
  notification.$on('sendMessage', (e)=>{
    customSendMessage(e)
  })
});

const customSendMessage = async (content: Object) => {
  const _editorContentList = [content]
  if (!_editorContentList || !currentConversation.value) return;
  const editorContentList = _editorContentList.map((editor: any) => {
    editor.payload.text = transformTextWithEmojiNamesToKeys(content.payload.text);
    return editor;
  });
  await sendMessages(
    editorContentList,
    currentConversation.value,
  );
  emit('sendMessage');
  editor.value?.resetEditor();
};

const sendMessage = async () => {
  const _editorContentList = editor.value?.getEditorContent();
  if (!_editorContentList || !currentConversation.value) return;
  const editorContentList = _editorContentList.map((editor: any) => {
    if (editor.type === 'text') {
      editor.payload.text = transformTextWithEmojiNamesToKeys(editor.payload.text);
    }
    return editor;
  });
  await sendMessages(
    editorContentList,
    currentConversation.value,
  );
  emit('sendMessage');
  editor.value?.resetEditor();
};

const insertEmoji = (emoji: any) => {
  editor.value?.addEmoji(emoji);
};

const onAtListOpen = () => {
  if (isH5) {
    editor.value?.blur();
  }
};

const insertAt = (atInfo: any) => {
  editor?.value?.insertAt && editor?.value?.insertAt(atInfo);
};

const reEdit = (content: any) => {
  editor.value?.resetEditor();
  editor.value?.setEditorContent(content);
};

expose({
  insertEmoji,
  reEdit,
});

return { __sfc: true,props, emit, editor, messageInputAtRef, currentConversation, onTyping, onAt, customSendMessage, sendMessage, insertEmoji, onAtListOpen, insertAt, reEdit, MessageInputEditor, MessageInputAt, MessageInputButton, MessageInputQuote, isPC }
}

})